import React from 'react';
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';
import './Footer.css';
import Logo from '../../assets/Images/logo.png';

const Footer = () => {
  return (
    <footer className="footer-section text-center py-5">

      <div className="d-flex justify-content-center mb-4">
        <img src={Logo} alt="Sharks Club Logo" className="footer-logo" />
      </div>

      <div className="container">
        <div className="row text-center">

          <div className="col-md-4">
            <h4 className="footer-heading">Open Hours</h4>
            <p>
              Mon - Sun : 11 am - 10 pm
              <br />
              Poya Day - Closed
            </p>
          </div>

          <div className="col-md-4">
            <h4 className="footer-heading">Contact</h4>
            <p>
              <a href='mailto:info@greenviewpeak.lk'>info@greenviewpeak.lk</a>
              <br />
              <i class="bi bi-phone"></i> +94 75-360-2965<br />
              <i class="bi bi-phone"></i> +94 76-369-1702<br />
              <i class="bi bi-whatsapp"></i> +94 77-360-2955
            </p>
          </div>

          <div className="col-md-4">
            <h4 className="footer-heading">Location</h4>
            <p>
              6M Buwanekaba Road
              <br />
              Gampola 20500 Sri Lanka
            </p>
          </div>



        </div>
      </div>

      <div className="social-icons-footer">
        <a href="https://www.facebook.com/profile.php?id=61550096803803" target="_blank" rel="noopener noreferrer">
          <FaFacebook className="social-icon facebook-icon" />
        </a>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
          <FaInstagram className="social-icon instagram-icon" />
        </a>
        <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
          <FaYoutube className="social-icon youtube-icon" />
        </a>
      </div>

      <div className="footer-bottom mt-5 py-5">
        <p className="mb-0" style={{ lineHeight: '1.5rem' }}>
          &copy; {new Date().getFullYear()} Green View Peak. All Rights Reserved.
        {/* <p className="mb-0" style={{fontSize: '0.8rem'}}>Website design and IT Solution : 
          <a href='https://www.adada.com.au/' className='text-danger fw-bold' style={{textDecoration: 'none'}}> ADADA Digital</a>
        </p> */}
      </p>
    </div>
    </footer >
  );
};

export default Footer;

